/** Telegram Web–inspired skin. */
import { MessengerWorkspace } from "../MessengerWorkspace";

export function TelegramShell() {
  return (
    <MessengerWorkspace kind="telegram" themeClass="theme-telegram" brand="Telegram" />
  );
}
